/* eslint-disable jest/require-hook */
import { candidatesPartiesRankingWidget } from '@sky-it-elections/widgets';

import DynamicPartiesRanking from './components/candidates-parties-ranking/dynamic-candidates-parties-ranking';
import DynamicMunicipalityList, {
  MUNICIPALITY_LIST_TAG,
} from './components/municipality-list/dynamic-municipality-list';
import DynamicMunicipalitySearch, {
  MUNICIPALITY_SEARCH_TAG,
} from './components/municipality-search/dynamic-municipality-search';
import DynamicComboBox, { COMBO_BOX_TAG } from './components/combo-box/dynamic-combo-box';
import DynamicSearchInput, { SEARCH_INPUT_TAG } from './components/search-input/dynamic-search-input';
import { COMBO_BOX_SLIDER_TAG } from './components/combo-box-slider/combo-box-slider-wrapper';
import { defineWebComponents } from './utils/web-components-utils';
import DynamicComboBoxWrapper from './components/combo-box-slider/dynamic-combo-box-wrapper';

const webComponentsMap = new Map();
webComponentsMap.set(candidatesPartiesRankingWidget.tag, DynamicPartiesRanking);
webComponentsMap.set(MUNICIPALITY_LIST_TAG, DynamicMunicipalityList); // TODO: Add DESCRIPTION on HOW this WIDGET is DIFFERENT
webComponentsMap.set(MUNICIPALITY_SEARCH_TAG, DynamicMunicipalitySearch); // TODO: Add DESCRIPTION on HOW this WIDGET is DIFFERENT
webComponentsMap.set(COMBO_BOX_TAG, DynamicComboBox);
webComponentsMap.set(SEARCH_INPUT_TAG, DynamicSearchInput);
webComponentsMap.set(COMBO_BOX_SLIDER_TAG, DynamicComboBoxWrapper);

defineWebComponents(webComponentsMap);
